import React, { useState } from "react";
import AccountModal from "./AccountModal";
import "../index.scss"
import NoAccountFoundLoader from "../../../../../../assets/images/noaccountsloaderbc.gif";
import { t } from "../../../../../utils/i18n";

const Account = ({ account, deleteAccount, index }) => {
  const [showAccountModal, setShowAccountModal] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleShowAccountModal = (e, value) => {
    e.preventDefault();

    setShowAccountModal(value);
  };

  const handleCopy = (text, field) => {
    navigator.clipboard.writeText(text);
    setCopied(field);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <tr className="bankaccountspage-tablebody-row">
      <td className="bankaccountspage-indexnumber-cont">
        <span className="bankaccountspage-indexnumber">{index + 1}</span>
        <span className="bankaccountspage-actions-mobileicons-cont">
          <a href="#" title={t("p2p.bank_table.view_details")} onClick={(e) => handleShowAccountModal(e, true)} className="bankaccountspage-actions-mobileeyeicon">
            <small>{t("p2p.bank_table.view")}</small> {" "}
            <i className="fas fa-eye"></i>
          </a>
        </span>
      </td>
      <td data-label={t("p2p.common.name_colon")}>{account.accountHolderName}</td>
      <td data-label={t("p2p.bank_table.bank_name_colon")}>
        <div>{account.bankName}</div>
        {/* <div className="font-0_9">{account.country?.name}</div> */}
      </td>
      <td data-label={account.ibanNumber ? t("p2p.bank_table.iban") : t("p2p.common.account_number")}>
      <div className="font-0_9">{account.ibanNumber ? (<span>{t("p2p.bank_table.iban_value", { value: account.ibanNumber })}</span>) : account.accountNumber}
        <button onClick={() => handleCopy(account.accountNumber, "accountNumber")} className="bankaccountspage-copybtn">
          <i className={`fas fa-${copied === "accountNumber" ? "check" : "copy"}`} title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
        </button>
      </div>
      </td>
      <td data-label={t("p2p.common.actions_colon")} className="bankaccountspage-table-actions bankaccountspage-table-mobileactions">
        <span className="bankaccountspage-actions-icons-cont">
          <a href="#" title={t("p2p.bank_table.view_details")} onClick={(e) => handleShowAccountModal(e, true, "")} className="bankaccountspage-actions-icons bankaccountspage-actions-hidemobile">
            <i className="fas fa-eye"></i>
          </a>

          <a
            href="#"
            title={t("p2p.common.delete")}
            className="bankaccountspage-actions-icons"
            onClick={(e) => {
              deleteAccount(e, account.id);
            }}
          >            
            <i className="fas fa-trash"></i>
          </a>
        </span>
      </td>
      {showAccountModal && (
        <AccountModal
          account={account}
          handleShowAccountModal={handleShowAccountModal}
        />
      )}
    </tr>
  );
};

export default Account;
